module.exports = __webpack_public_path__ + "fonts/nuxt-fontagon-icon.4c985b5.woff";